import "./atoms-v2886.js";
import { getValueTransition as M } from "./atoms-v21089.js";
import { positionalKeys as S } from "./atoms-v21080.js";
import { setTarget as A } from "./atoms-v21088.js";
import { addValueToWillChange as H } from "./atoms-v21090.js";
import { getOptimisedAppearId as y } from "./atoms-v21091.js";
import { animateMotionValue as B } from "./atoms-v21092.js";
import { frame as V } from "./atoms-v2949.js";
function I({ protectedKeys: t, needsAnimating: a }, n) {
  const i = t.hasOwnProperty(n) && a[n] !== !0;
  return a[n] = !1, i;
}
function W(t, a, { delay: n = 0, transitionOverride: i, type: m } = {}) {
  var r;
  let { transition: p = t.getDefaultTransition(), transitionEnd: e, ...d } = a;
  i && (p = i);
  const f = [], u = m && t.animationState && t.animationState.getState()[m];
  for (const o in d) {
    const s = t.getValue(o, (r = t.latestValues[o]) !== null && r !== void 0 ? r : null), c = d[o];
    if (c === void 0 || u && I(u, o))
      continue;
    const l = {
      delay: n,
      ...M(p || {}, o)
    };
    let T = !1;
    if (window.MotionHandoffAnimation) {
      const h = y(t);
      if (h) {
        const w = window.MotionHandoffAnimation(h, o, V);
        w !== null && (l.startTime = w, T = !0);
      }
    }
    H(t, o), s.start(B(o, s, c, t.shouldReduceMotion && S.has(o) ? { type: !1 } : l, t, T));
    const g = s.animation;
    g && f.push(g);
  }
  return e && Promise.all(f).then(() => {
    V.update(() => {
      e && A(t, e);
    });
  }), f;
}
export {
  W as animateTarget
};
